import './home.scss';
import { getLatestMovie } from "../../data/movies";
import { ReactElement } from "react";
import React from "react";
import FilmOutlet from "../movies/filmOutlet/filmOutlet";


export default function Home(): ReactElement {
  const currentMovie = getLatestMovie();

  return (
    <div>
      {/* use the following div to show an announcement */}
      {/*<div className="app-body bg-secondary w-100 m-0 py-4 d-flex justify-content-center text-light">
        <div className="d-flex flex-row align-items-center">
          <i className="bi bi-camera-reels fs-1"></i>
          <div className="ms-3">
            <p className="fs-6 p-0 m-0">{t("home.announcement.body")}</p>
            <a className="link-light fs-6" href="https://whatsapp.com/channel/0029Vb62Tbu11ulNs6T7Zy02" target="_blank"
               rel="noreferrer">{t("home.announcement.link")}</a>
          </div>
        </div>
      </div>*/}

      <FilmOutlet currentMovie={currentMovie}/>
    </div>
  );
}